export class NgxTranslationOptions {
    production: boolean = false;
    dictionary: NgxTranslationDictionary[] = [];
}

export interface NgxTranslationDictionary {
    languages: string[];
    locale: string;
    data: object;
    name: string;
}

export interface NgxTranslation {
    token: string;

    translate?: boolean;
    data?: NgxTranslationExtras;
}

export interface NgxTranslationExtras {
    [token: string]: string;
}
